
define('text!pages/media/upload_modal_template.html',[],function () { return '<p>\r\n  <%= _.t(\'modal.text.file_uploads_image\') %>\r\n</p>\r\n\r\n<p>\r\n  <%= _.t(\'modal.text.file_uploads_video\') %>\r\n</p>\r\n<p>\r\n  <button class="button button-primary js-cancel-button"><%- _.t(\'modal.button.confirm\') %></button>\r\n</p>\r\n';});

